exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".el-button.is-round{border-radius:50px}.el-button--primary{background-color:#00b9ff;border-color:#00b9ff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/assets/css/override-element-ui.css
// module id = 136
// module chunks = 1